// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tizp","importantInfo":"styles_importantInfo__2HqJP"};